import React from 'react';
import ReproRequests from './ReproRequests.js';

/**
 * Render the ownership-scoped Reprographics queue for non-manager requesters.
 */
export default function ReproUserRequests() {
  return <ReproRequests requesterMode />;
}
